import React from 'react';
import Unauthorized from '../common/Error/Unauthorized/Unauthorized';
import { Configuration } from "../../configs/Configuration";

import { setAuthToken } from '../../helpers/authHelper';
import { DASHBOARD_HOME_PATH, DASHBOARD_SURVEY_PATH, PREFERENCES_BASE_PATH } from '../../constants/paths';
import { fetchUserHash } from '../../dataFetchers/noAuthDataFetcher';
import { parseQueryParams } from '../../helpers/URLHelper';
import { SSO_DESTINATION } from '../../constants/common';
import { bidgelyStorage } from '../../helpers/storageHelper';

class SsoAuthenticationLayer extends React.Component {
  state = {
    errorCode: null
  };

  componentDidMount() {
    let parsedString = null;
    if (this.props.location.search !== "") {
      parsedString = parseQueryParams(this.props.location.search);
      this.setState({
        errorCode: parsedString["error-code"]
      });
    }
    if (!parsedString["error-code"]) {
      let path = DASHBOARD_HOME_PATH;
      let destination = parsedString.destination;
      let token = parsedString.token;
      let uuid = parsedString.uuid;
      // query param to show cobrowsing banner
      let scb = parsedString.scb;
      let configuration = Configuration.getConfiguration();

      setAuthToken(token);
      bidgelyStorage.setItem('authToken', token);
      bidgelyStorage.setItem('sso', true);
      if (scb === "1") {
        bidgelyStorage.setItem('isCobrowsing', true);
      }
      fetchUserHash(uuid, configuration.pilotId).then(
        (userHash) => {
          bidgelyStorage.setItem('userHash', userHash);
          switch (destination) {
            case SSO_DESTINATION.DASHBOARD:
              path = DASHBOARD_HOME_PATH
              break;
            case SSO_DESTINATION.SURVEY:
              path = DASHBOARD_SURVEY_PATH
              break;
            case SSO_DESTINATION.PREFERENCES:
              path = PREFERENCES_BASE_PATH
              break;
            default:
              break;
          }
          this.props.history.replace(path);
        }
      );
    }
  }

  render() {
    const { errorCode } = this.state;
    return(
      <> { (errorCode) ?
        <Unauthorized errorCode={errorCode} /> : ''}
      </>
    );
  }
};

export default SsoAuthenticationLayer;
